import { ComponentType } from 'react';

import { Element, Processor } from '@/features/html2react/types';

import NextVideo, { VideoProps } from '../components/video/index';

interface VideoElement extends Element {
  props: Element['props'] & VideoProps;
}

const video: Processor<VideoElement> = {
  priority: 97,
  name: 'video',
  test: ({ node }) => node.component === 'video',
  processor: ({ node }) => {
    node.component = NextVideo as ComponentType;
    return node;
  }
};

export default video;
